import jwt_decode from "jwt-decode";
import { Types } from "../actionTypes"
import { api, setTokens } from '../../api/api'


import {
  setLog,
  types as errorTypes
} from '../../common/utilities/LogError'

let global_baseURL = ''
let global_dispatch = {}

const cleanPayload = data => {
  const token = data.tokens[0] || {}

  const {
    enabled_parking = false,
    enabled_workplace = false,
    enabled_room_reservations = false,
    enabled_manual_checkin = false,
    enabled_parking_reservations_manual_checkin = false,
    enabled_room_reservations_manual_checkin = false
  } = token

  return {
    ...data,
    enabled_parking,
    enabled_workplace,
    enabled_room_reservations,
    enabled_manual_checkin,
    enabled_parking_reservations_manual_checkin,
    enabled_room_reservations_manual_checkin
  }
}

const messageListener = event => {
  const { data, origin } = event
  const url = global_baseURL.replace('/api', '')
  if (origin !== url) return
  window.global_tab?.close()
  window.removeEventListener("message", messageListener)

  const {
    access_token,
    client,
    uid
  } = data

  setTokens({
    'access-token': access_token,
    'client': client,
    'token-type': 'Bearer',
    'uid': uid
  })

  const config = {
    headers: {
      'access-token': access_token,
      'client': client,
      'token-type': 'Bearer',
      'uid': uid
    }
  }

  api.get('/auth/validate_token', {}, config)
    .then(({ data }) => {
      global_dispatch({
        type: Types.SET_AUTH,
        payload: cleanPayload(data)
      })
    })
}

const ssoDeskTeamsAuth = access_token => {
  return function (dispatch) {
    
    const {
      tid,
      preferred_username
    } = jwt_decode(access_token).payload

    const params = {
      access_token,
      tenant_id: tid,
      email: preferred_username
    }

    api.post('/graph/validate', params)
      .then(({ data }) => {
        if (!data.success) {
          setAlert({
            open: true,
            content: "Error validateAccessToken: " + data.message,
            danger: true,
            autoHideDuration: 10000
          }) 
          return
        }

        setTokens(data.tokens[0].token)
        dispatch({
          type: Types.SET_AUTH,
          payload: cleanPayload(data)
        })
      })
  }
}

const ssoDeskTeamsError = error => { 
  setAlert({
    open: true,
    content: "Error getting token: " + error,
    danger: true,
    autoHideDuration: 10000
  })  
}

const ldapAuth = ({ password }, data) => {
  return function (dispatch) {
    const { user_name, provider } = data.auth_types[0]
    const _data = { user_name, provider, password }
    return api.post('/users/ldap/sign_in', _data)
      .then(({ data }) => {
        const { success, errors } = data
        if (!success) {
          if (errors === 'Usuario/contraseña inválido') {
            throw new Error('password is incorrect')
          }
          throw new Error('unknown error')
        }
        setTokens(data.tokens[0].token)
        dispatch({
          type: Types.SET_AUTH,
          payload: cleanPayload(data)
        })
      })
  }
}

const ssoAuth = (data, baseURL) => {
  return function (dispatch) {
    const { provider = '' } = data
    const route = `/users/saml/sign_in?web=true&provider=${provider}`
    global_baseURL = baseURL
    global_dispatch = dispatch
    window.addEventListener("message", messageListener, false)
    return `${baseURL}${route}`
  }
}

  const sendCode = (code, email, t) => {
    return function (dispatch) {
      const params = { code, email }
      setLoading(true)
      api.post('/sac/validate', params)
        .then(({ data }) => {
          if (!data.success) return
          setTokens(data.tokens[0].token)
          dispatch({
            type: Types.SET_AUTH,
            payload: cleanPayload(data)
          })
        }).catch(error => {
          console.log(error)
          dispatch({
            type: Types.SET_ALERT_DATA,
            payload: {
              open: true,
              content: t("The access code is invalid"),
              danger: true,
              autoHideDuration: 2000
            }
          })
        })
    }
  }

const deviseAuth = (payload, baseURL) => {
  return function (dispatch) {
    return api.post('/auth/sign_in', payload, { baseURL })
      .then(({ data }) => {
        dispatch({
          type: Types.SET_AUTH,
          payload: cleanPayload(data)
        })
      })
  }
}

const setLoading = loading => {
  return function (dispatch) {
    dispatch({
      type: Types.SET_BACKDROP_LOADING,
      payload: { loading }
    })
  }
}

const setAlert = payload => {
  return function (dispatch) {
    dispatch({
      type: Types.SET_ALERT_DATA,
      payload
    })
  }
}

const setDomain = domain => {
  return function (dispatch) {
    dispatch({
      type: Types.SET_DOMAIN,
      payload: domain
    })
  }
}

const defaultSuccess = r => {
  return function (dispatch) {
    setLoading(false)(dispatch)
    return r
  }
}

const defaultCatch = (error, history) => {
  return function (dispatch) {
    setLoading(false)

    if (error?.response?.status === 401) logout(history)(dispatch)
    else if (error.response) {
      setLog({
        title: error.response.status,
        type: errorTypes.API_ERROR,
        message: error.response.data.errors,
        api_url: error.response.config.url,
        api_method: error.response.config.method,
        api_params: error.response.config.data
      })
    } else setLog({ type: errorTypes.API_ERROR, message: error.message })
  }
}

const logout = history => {
  return function (dispatch) {
    dispatch({ type: Types.CLEAN_AUTH })
    history.push('/tab/login')
  }
}

const _dispatch = dispatch => {
  return dispatch
}

export {
  _dispatch,
  logout,
  defaultSuccess,
  defaultCatch,
  sendCode,
  ssoAuth,
  ssoDeskTeamsAuth,
  ssoDeskTeamsError,
  ldapAuth,
  deviseAuth,
  setLoading,
  setAlert,
  setDomain
}